
import * as Sentry from '@sentry/react'
import package_data from './../package.json'

const packageVersion = package_data.version

if (process.env.REACT_APP_NODE_ENV !== 'development') {
    Sentry.init({
        dsn: 'https://89beac87958242498064e23197071c67@o392495.ingest.sentry.io/5932093',
        ignoreErrors: [
            'TypeError: ChunkLoadError',
            'AbortError: The operation was aborted.',
            '/^UnhandledRejection: Non-Error promise rejection captured with value/',
            `Failed to execute 'insertBefore' on 'Node': The node before which the new node is to be inserted is not a child of this node.`,
            'The operation is insecure',
            `Failed to execute 'removeChild' on 'Node': The node to be removed is not a child of this node.`,
            'IndexSizeError: The index is not in the allowed range.',
            'WKWebView API client did not respond to this postMessage',
            'AbortError: The play() request was interrupted by a new load request.',
            `Failed to read the 'localStorage' property from 'Window': Access is denied for this document.`,
            'Type error',
            `undefined is not an object (evaluating 'this.mediaController.media.webkitCurrentPlaybackTargetIsWireless')`
        ],
        integrations: [Sentry.browserTracingIntegration()],
        // We recommend adjusting this value in production, or using tracesSampler
        // for finer control
        tracesSampleRate: 0.001,
        release: packageVersion
    })
}

